import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPostCategory } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import parseError from "../../../utils/parseError";

export const useCreatePostCategory = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutate: createCategoryMutate, isPending: isCreating } = useMutation({
        mutationFn: createPostCategory,
        onSuccess: (res) => {
            toast.success(res.message || "Category created successfully");
            queryClient.invalidateQueries(["post-categories"]);
            navigate("/blog/categories");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create category");
        },
    });

    return { createCategoryMutate, isCreating };
};
